import { Modal, Text, Group, Button, Stack } from '@mantine/core';

export interface DeleteConfirmationModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName?: string;
  isLoading?: boolean;
}

export function DeleteConfirmationModal({ opened, onClose, onConfirm, itemName, isLoading = false }: DeleteConfirmationModalProps) {
  return (
    <Modal opened={opened} onClose={onClose} title="Confirm Deletion" centered>
      <Stack gap="md">
        <Text>
          Are you sure you want to delete {itemName ? <strong>{itemName}</strong> : 'this item'}? This action cannot be undone.
        </Text>
        <Group justify="flex-end">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button color="red" onClick={onConfirm} loading={isLoading}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
} 
